
<form id="signup" [formGroup]="signUpForm" (submit)="signUpForm.valid && signUp()">
    <h5 i18n="@@billingInfo">Billing Information</h5>


    <div class="row">
        <div class="col-sm-12 col-md-6">

            <div class="form-group">
                <label i18n>First name</label>
                <input type="text"
                       id="address_first_name"
                       placeholder=""
                       [ngClass]="{'is-invalid':signUpForm.get('address_first_name').touched && signUpForm.get('address_first_name').invalid}"
                       class="form-control"
                       formControlName="address_first_name"
                       required="" ngModel
                       aria-required="true">
                <div class="invalid-feedback">
                    <div i18n>Address first name is required</div>
                </div>
            </div>
        </div>

        <div class="col-sm-12 col-md-6">
            <div class="form-group">
                <label i18n>Last name</label>
                <input type="text"
                       id="address_last_name"
                       name="address_last_name"
                       placeholder=""
                       [ngClass]="{'is-invalid':signUpForm.get('address_last_name').touched && signUpForm.get('address_last_name').invalid}"
                       class="form-control"
                       formControlName="address_last_name"
                       required="" ngModel
                       aria-required="true">
                <div class="invalid-feedback">
                    <div i18n>Address last name is required</div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">


        <div class="col-md-3 col-sm-12">
            <div class="form-group">
                <label i18n>City</label>
                <input type="text"
                       id="city"
                       name="city"
                       placeholder=""
                       [ngClass]="{'is-invalid':signUpForm.get('city').touched && signUpForm.get('city').invalid}"
                       class="form-control"
                       formControlName="city"
                       required="" ngModel
                       aria-required="true">
                <div class="invalid-feedback">
                    <div i18n>City is required</div>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="form-group">
                <label i18n>Street</label>
                <input type="text"
                       id="street"
                       name="street"
                       placeholder=""
                       [ngClass]="{'is-invalid':signUpForm.get('street').touched && signUpForm.get('street').invalid}"
                       class="form-control"
                       formControlName="street"
                       required="" ngModel
                       aria-required="true">
                <div class="invalid-feedback">
                    <div i18n>Street is required</div>
                </div>
            </div>
        </div>

        <div class="col-md-3 col-sm-12">

            <div class="form-group">
                <label i18n>Phone</label>
                <input type="text"
                       id="phone"
                       name="street"
                       placeholder=""
                       [ngClass]="{'is-invalid':signUpForm.get('phone').touched && signUpForm.get('phone').invalid}"
                       class="form-control"
                       formControlName="phone"
                       required="" ngModel
                       aria-required="true">
                <div class="invalid-feedback">
                    <div i18n>Phone is required</div>
                </div>
            </div>
        </div>

    </div>
    <div>

        <div class="text-right mt-2 pull-right">

            <button id="new_user_btn" class="btn btn-success"
                    type="submit"
                    i18n="@@savebtn"
            >
                               <span style="width: 40px;">
                    <img src="assets/loader.gif" style="width: 20px !important;" *ngIf="isLoggingIn"/>
                    <i style="width: 20px " class="la la-arrow-right" *ngIf="!isLoggingIn"></i>
                </span>
               Save
            </button>

        </div>
    </div>


</form>




